import React, { useState } from 'react';

import {
    mobileSupportPageSignal,
    mobileSupportRetryPageSignal,
} from 'features/mobile-report/state/mobile-report.signals';
import { Button } from 'ui-components/button/button';
import { LeftArrowIcon } from 'components/assets/Icons/IconsMobile';
import { InputField, TextAreaField } from '@placer-ui/components';
import { supportApi } from 'API/offline-reports-api/support-api';

import styles from './mobile-support-pages.module.scss';

export const AskSupportMobile = () => {
    const [subject, setSubject] = useState('');
    const [comment, setComment] = useState('');
    const [isSendingRequest, setIsSendingRequest] = useState(false);

    const handleClose = () => {
        mobileSupportPageSignal.value = undefined;
    };

    const handleApply = async () => {
        setIsSendingRequest(true);
        try {
            await supportApi.submitRequest({
                type: 'question',
                subject,
                additionalInformation: comment,
                isMobile: true,
            });
            setIsSendingRequest(false);
            mobileSupportPageSignal.value = 'success';
        } catch (e) {
            setIsSendingRequest(false);
            mobileSupportRetryPageSignal.value = 'askSupport';
            mobileSupportPageSignal.value = 'failed';
        }
    };

    return (
        <>
            <div className={styles.header}>
                <Button
                    data-testid="customize-back-button"
                    type="link"
                    className={styles.backIcon}
                    onClick={handleClose}
                >
                    <LeftArrowIcon />
                </Button>
                <div className={styles.heading}>
                    <h2 className={styles.title}>Ask Support a Question</h2>
                    <p className={styles.subTitle}>
                        Found something that we can fix? Couldn’t find an answer in our Help Center?
                        We’re happy to help!
                    </p>
                </div>
            </div>
            <div className={styles.contactForm}>
                <div>
                    <InputField
                        value={subject}
                        onChange={setSubject}
                        label="Subject"
                        placeholder="Provide a clear subject for your request"
                        maxLength={100}
                        required
                        asterix
                        testId="ask-support-mobile-subject"
                    />
                </div>
                <TextAreaField
                    value={comment}
                    onChange={setComment}
                    label="Additional Information"
                    placeholder="Share additional details to help our support team assist you better (optional)."
                    initialHeight={104}
                    maxLength={1000}
                    testId="ask-support-mobile-details"
                />
            </div>
            <Button
                className={styles.mainButton}
                type="primary"
                onClick={handleApply}
                disabled={!subject || isSendingRequest}
                loading={isSendingRequest}
                data-testid="ask-support-mobile-submit"
            >
                Submit
            </Button>
        </>
    );
};
